'use client'

import {
  getApps,
  initializeApp,
} from 'firebase/app'

import {
  getMessaging,
  getToken,
  isSupported,
} from 'firebase/messaging'

const firebaseConfig = {
  apiKey:
    process.env
      .NEXT_PUBLIC_FIREBASE_API_KEY!,
  authDomain:
    process.env
      .NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
  projectId:
    process.env
      .NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
  storageBucket:
    process.env
      .NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId:
    process.env
      .NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID!,
  appId:
    process.env
      .NEXT_PUBLIC_FIREBASE_APP_ID!,
}

export const firebaseApp =
  getApps().length > 0
    ? getApps()[0]
    : initializeApp(firebaseConfig)

export async function setupFirebaseMessaging(
  onToken: (token: string) => void
) {
  console.log(
    '[firebase-push] checking support'
  )

  const supported =
    await isSupported()

  console.log(
    '[firebase-push] supported:',
    supported
  )

  if (!supported) {
    return {
      supported: false,
      messaging: null,
    }
  }

  console.log(
    '[firebase-push] registering service worker'
  )

  const serviceWorkerRegistration =
    await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
        {
        scope: '/firebase-cloud-messaging-push-scope/',
        }
    )

  console.log(
    '[firebase-push] service worker registered',
    serviceWorkerRegistration.scope
  )

  const messaging =
    getMessaging(firebaseApp)

  const fcmToken =
    await getToken(messaging, {
      vapidKey:
        process.env
          .NEXT_PUBLIC_FIREBASE_VAPID_KEY!,
      serviceWorkerRegistration,
    })

  console.log(
    '[firebase-push] FCM TOKEN:',
    fcmToken
  )

  if (fcmToken) {
    onToken(fcmToken)
  }

  return {
    supported: true,
    messaging,
  }
}